import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { addUpdateCartingSeries } from "../api/addUpdateCartingSeries";

export const useAddUpdateCartingSeries = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => addUpdateCartingSeries(body),
    onSuccess: () => {
      toast.success("Saved successfully.");
      queryClient.invalidateQueries({ queryKey: ["allSeriesCarting"] });
      queryClient.invalidateQueries({ queryKey: ["syncStatus"] });
      queryClient.invalidateQueries({ queryKey: ["pendingChanges", "carting"] });
    },
    onError: () => {
      toast.error("Failed to save. Please try again.");
    },
  });
};

